import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
} from 'react-admin';

// Remove manual pagination when Material-UI bug has been fixed
// See Components/Pagination for github link to issue
import { Pagination } from 'Components';

const HelpList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    exporter={false}
    perPage={50}
    pagination={<Pagination />}
  >
    <Datagrid>
      <TextField source="question" sortable={false} />
      <TextField source="orderIndex" sortable={false} />
      <EditButton />
    </Datagrid>
  </List>
);

export default HelpList;
